import { SPECIES } from '@/lib/speciesBreeds';
/**
 * Species a hanging protocol can target: every species the pickers offer except 'Other'.
 *
 * 'Other' is the picker's escape hatch for "a species our list does not carry", so a protocol
 * aimed at it would match nothing in particular. Derived from the master list rather than
 * retyped, so a species added there shows up here (detectSpecies.ts then fails to compile until
 * it has hints for it).
 */
export const HANGING_PROTOCOL_SPECIES = SPECIES.filter((s) => s !== 'Other');
/**
 * Translation key for a species chip. Shares the report-template editor's species names
 * (settings namespace) so one animal reads the same in both places.
 */
export function speciesLabelKey(species) {
    return `reporting.templateEditor.${species.toLowerCase()}`;
}
